import m from '@bitstillery/mithril'
import {MithrilComponent} from '@bitstillery/mithril'
import {present} from '@bitstillery/common/lib/utils'

/** lib.dom types `body` as always there, but a document that was never written has none. */
const body_of = (doc: Document): HTMLElement | null => doc.body

const set_iframe_height = (iframe: HTMLIFrameElement) => {
    const doc = iframe.contentDocument || present(iframe.contentWindow, 'iframe window').document
    const set_height = () => {
        const body = body_of(doc)
        const height = body ? body.scrollHeight : doc.documentElement.scrollHeight
        iframe.style.height = height + 'px'
    }
    const body = body_of(doc)
    if ((window.ResizeObserver as typeof ResizeObserver | undefined) && body) {
        const observer = new window.ResizeObserver(set_height)
        observer.observe(body)
        set_height()
    } else {
        set_height()
        setInterval(set_height, 500)
    }
}

/** Every attr is forwarded to the <iframe> element. */
type IframeAttrs = Record<string, unknown>

const proxy = function (vnode: m.Vnode<IframeAttrs> & {dom?: HTMLIFrameElement | null}) {
    if (vnode.dom?.tagName !== 'IFRAME' || !vnode.dom.contentWindow) {
        return
    }
    const doc = vnode.dom.contentDocument || vnode.dom.contentWindow.document

    if (doc.readyState === 'complete') {
        // Render into <body>, not <html>. Rendering trusted fragments onto documentElement
        // breaks the document tree and often shows an empty preview (email HTML is body content).
        if (!body_of(doc)) {
            doc.open()
            doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>')
            doc.close()
        }
        m.render(doc.body, vnode.children)
        set_iframe_height(vnode.dom)
    } else {
        setTimeout(function () {
            proxy(vnode)
        }, 0)
    }
}

/**
 * A same-origin Iframe component that can be used to
 * dynamically render Mithril component inside. Most common
 * use-case is to render html content isolated from other
 * CSS styles.
 */
export class Iframe extends MithrilComponent<IframeAttrs> {
    override oncreate = proxy
    override onupdate = proxy

    view(vnode: m.Vnode<IframeAttrs>) {
        return <iframe {...vnode.attrs} className='c-iframe' />
    }
}
